export default "__VITE_ASSET__5Ntqnbnn__"